import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Scrollbars } from 'react-custom-scrollbars'
import FilterBtn from './FilterBtn'

class CategoryFilter extends React.Component {

  constructor(props) {
    super(props)
    this.state = { isOpen: props.expandByDefault }
  }

  handleToggleClick() {
    this.setState({ isOpen: !this.state.isOpen })
  }

  handleFilterBtnClick(taxonomy, termId) {
    this.props.dispatch({
      type: 'TOGGLE_FILTER',
      taxonomy,
      termId,
    })
  }

  makeFilterBtnAprType(type) {
    let label;
    switch (type) {
      case 'media':         label = 'Outils multimédia'; break
      case 'actualite':     label = 'Actualités'; break
      case 'quiz':          label = 'Quiz'; break
      case 'dossier':       label = 'Dossiers'; break
      case 'statistique':   label = 'Statistiques'; break
      case 'fichepratique': label = 'Fiches pratiques'; break

      // disabled:
      case 'normal':      return null //; label = 'Actualités'; break

      default:          label = type; break
    }
    return <FilterBtn
      key         = { type }
      taxonomy    = 'apr_type'
      onClick     = { this.handleFilterBtnClick.bind(this, 'apr_type', type) }
      active      = { this.props.filters.apr_type === type }
    >{ label }</FilterBtn>
  }


  makeFilterBtn(taxonomy, term) {
    return <FilterBtn
      key         = { term.term_id }
      taxonomy    = { taxonomy }
      onClick     = { this.handleFilterBtnClick.bind(this, taxonomy, term.term_id) }
      active      = { this.props.filters[taxonomy] && this.props.filters[taxonomy] === term.term_id }
    >{ term.name }</FilterBtn>
  }


  render() {

    const link = null === this.props.submitUrl
      ? null
      :  <div className='category-filters__submit text-right'>
           <a className='btn btn-base' href={this.props.submitUrl}>Filtrer</a>
         </div>

    const filter1 = this.props.filter1
      ? <div className='col-sm-9'>
          <div className='category-filters__title'>{ this.props.filter1.label }</div>
          <div className='category-filters__filter-btns'>
            { apr_data.taxonomies[ this.props.filter1.key ].map(this.makeFilterBtn.bind(this, this.props.filter1.key )) }
          </div>
        </div>
      : null

    const filter2 = this.props.filter2
      ? <div className='col-sm-9'>
          <div className='category-filters__title'>{ this.props.filter2.label }</div>
          <div className='category-filters__filter-btns'>
            { apr_data.taxonomies[ this.props.filter2.key ].map(this.makeFilterBtn.bind(this, this.props.filter2.key )) }
          </div>
        </div>
      : null


    return <div>
      <div className={ this.props.className }>
        <div className='row'>
          <div className='col-sm-3'>
            <div className='category-filters__title'>Mode de transport&nbsp;:</div>
            <Scrollbars
              className           = 'custom-scrollbar'
              style               = {{ height: '10em' }}
              scrollbarHorizontal = {({ style, ...props }) => <div style={{ ...style }} { ...props } />}
              thumbHorizontal     = {({ style, ...props }) => <div style={{ ...style }} { ...props } />}
              scrollbarVertical   = {({ style, ...props }) => <div className='custom-scrollbar__bar' style={{ ...style }} { ...props } />}
              thumbVertical       = {({ style, ...props }) => <div className='custom-scrollbar__thumb' style={{ ...style }} { ...props } />}
              view                = {({ style, ...props }) => <div className='category-filters__filter-list' style={{ ...style }} { ...props } />}
            >
              { apr_data.taxonomies.transport.map(this.makeFilterBtn.bind(this, 'transport')) }
            </Scrollbars>
          </div>
          { filter1 }
        </div>
        <div className={ this.state.isOpen ? 'collapsible-filter' : 'collapsible-filter collapsed' }>
          <hr />
          <div className='row'>
            <div className='col-sm-3'>
              <div className='category-filters__title'>Format&nbsp;:</div>
              <div className='category-filters__filter-btns'>
                <FilterBtn key         = { 0 }
                           taxonomy    = 'apr_type'
                           onClick     = { this.handleFilterBtnClick.bind(this, 'apr_type', null) }
                           active      = { !this.props.filters.apr_type }
                >Tous</FilterBtn>
                { apr_data.apr_types.map(this.makeFilterBtnAprType.bind(this)) }
              </div>
            </div>
            { filter2 }
          </div>
        </div>
        <div className={ this.state.isOpen ? 'category-filters__toggle' :  'category-filters__toggle collapsed' }><div onClick={this.handleToggleClick.bind(this)}>de filtres</div></div>
      </div>
      { link }
    </div>
  }

}

CategoryFilter.defaultProps = {
  expandByDefault: false,
  submitUrl: null,
}

CategoryFilter.propTypes = {
  className: PropTypes.string.isRequired,
  expandByDefault: PropTypes.bool,
  submitUrl: PropTypes.string,
  filter1: PropTypes.shape({
    label: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  filter2: PropTypes.shape({
    label: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
}

function mapStateToProps({ filters }) {
  return { filters }
}

export default connect(mapStateToProps)(CategoryFilter)

// vi: et shiftwidth=2 tabstop=2 softtabstop=2



// WEBPACK FOOTER //
// ./js/website/react_components/CategoryFilter.js